<template>
    <span>{{ value }}</span>
</template>

<script>
export default {
  name: 'CellRendererConcat',
  computed: {
    value () {
      const { data, valueFields, join } = this.params;

      if (!valueFields) {
        return '';
      }

      const joinChar = join || ', ';
      const values = valueFields.map((valueField) => {
        return data[valueField];
      });

      return values.filter(Boolean).join(joinChar)
    }
  }
}
</script>
